import { __decorate } from "tslib";
import { NgModule } from 'angular-ts-decorators';
import { ReportPageFormComponent } from './report-page-form/report-page-form.component';
import { ReportPageComponent } from './report-page/report-page.component';
import { SupportShareComponent } from './support-share/support-share.component';
import { SupportWtuComponent } from './support-wtu/support-wtu.component';
var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        NgModule({
            declarations: [
                ReportPageFormComponent,
                ReportPageComponent,
                SupportShareComponent,
                SupportWtuComponent,
            ],
            id: 'gn.audio.support.shared',
            imports: [],
            providers: [],
        })
    ], SharedModule);
    return SharedModule;
}());
export { SharedModule };
